import axios from "axios";
import {
  getAuthHeaders,
  getBasicAuthHeadersElastic,
  getBasicAuthHeaders
} from "../helpers";

/**
 * @function getClinicGroupList
 * @param id
 * @description This function  will fetch the clinic group list.
 */
export const getClinicGroupList = id => {
  const url = `${process.env.REACT_APP_SERVER_URL}/clinic_groups/clinics?clinic_id=${id}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getDoctorsList
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the clinic group list.
 */
export const getDoctorsList = (pageNo, searchText, stateName) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/doctors?page=${pageNo}&perpage=10`;

  if (searchText) {
    url = url + "&search_text=" + searchText;
  }

  if (stateName) {
    url = url + "&filter_type=status&filter_text=" + stateName;
  }
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getDoctorDetails
 * @desc  get doctor details
 */

export const getDoctorDetails = doctorId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/doctors/${doctorId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getClinicSpecialities
 * @param "name"
 * @description Get clinic specialities
 */
export const getClinicSpecialities = (name = null) => {
  let url = `${process.env.REACT_APP_ES_SERVER_URL}/${process.env.REACT_APP_BASIC_SPECIALITIES_INDEX}/_search`;
  const params = {
    query: {
      bool: {
        must: []
      }
    },
    from: 0,
    size: 20
  };
  if (name) {
    params.query.bool.must.push({
      match_phrase_prefix: { name: name }
    });
  }
  params.query.bool.must.push({ term: { major_speciality: true } });

  return axios.post(url, params);
};

/**
 * @function getClinicSpecialities
 * @param "name"
 * @description Get clinic specialities
 */
export const getBasicClinicSpecialities = (name = null) => {
  let url = `${process.env.REACT_APP_ES_SERVER_URL}/${process.env.REACT_APP_BASIC_CLINIC_SPECIALITIES_INDEX}/_search`;

  const params = {
    query: {
      bool: {
        must: []
      }
    },
    from: 0,
    size: 20
  };
  if (name)
    params.query.bool.must.push({
      match_phrase_prefix: { name }
    });

  return axios.post(url, params);
};

/**
 * @function getStats
 * @desc  get stats
 */

export const getStats = () => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/doctors/news_stats`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getStats
 * @desc  get stats
 */

export const getAnalytics = (pageNo, sortOrder, sortBy) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/news_tags?page=${pageNo}&perpage=10`;
  if (sortOrder && sortBy)
    url = `${url}&sort_by=${sortBy}&sort_order=${sortOrder}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getDoctorProfile
 * @desc  get doctor details
 */

export const getDoctorProfile = doctorId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/doctors/${doctorId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getBasicSpecialities
 * @param searchText
 * @desc this service handles fetching basic specialities
 */
export const getBasicSpecialities = searchText => {
  let url = `${process.env.REACT_APP_ES_SERVER_URL}/${process.env.REACT_APP_BASIC_SPECIALITIES_INDEX}/_search`;
  const params = {
    query: {
      bool: {
        must: []
      }
    },
    from: 0,
    size: 20
  };
  if (searchText)
    params.query.bool.must.push({
      match_phrase_prefix: { name: searchText }
    });

  return axios.post(url, params);
};

/**
 * @function getProfileDetails
 * @param "doctorId"
 * @desc this function fetch the doctor details
 */
export const getProfileDetails = doctorId => {
  const url = `${process.env.REACT_APP_SERVER_URL}/doctors/${doctorId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function updateProfileDetails
 * @param "doctorDetail"
 * @desc this function update doctor's basic info
 */
export const updateProfileDetails = doctorDetail => {
  const url = `${process.env.REACT_APP_SERVER_URL}/doctors`;
  return axios.post(url, doctorDetail, {
    headers: getAuthHeaders()
  });
};

/**
 * @function verifyDoctor
 * @param "doctorId", "educationId"
 * @desc this function deletes doctor education
 */
export const verifyDoctor = (doctorId, doctordData) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/doctors/${doctorId}/verify`;
  return axios.post(
    url,
    { ...doctordData },
    {
      headers: getAuthHeaders()
    }
  );
};

/**
 * @function getDoctors
 * @desc This gets the doctors list.
 */
export const getDoctorsByPhoneNumber = phone => {
  const url = `${process.env.REACT_APP_SERVER_URL}/doctors?phone_number=${phone}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function addNewDoctor
 * @param clinicID
 * @param doctorId
 * @desc This services handles saving doctor detail
 */
export const addNewDoctor = (clinicID, doctorObj) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors`;
  return axios.post(url, doctorObj, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getDoctorDetail
 * @param clinicID
 * @param doctorId
 * @desc This services handles getting doctor detail
 */
export const getClinicDoctorDetail = (clinicID, doctorId) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors/${doctorId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function updateClinicDoctor
 * @param clinicID
 * @param doctorId
 * @param doctorObj
 * @desc This services handles updation of doctor
 */
export const updateClinicDoctor = (clinicID, doctorId, doctorObj) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors/${doctorId}`;
  return axios.put(url, doctorObj, {
    headers: getAuthHeaders()
  });
};

/**
 * @function saveDoctorSchedule
 * @param doctorId
 * @param doctorObj
 * @desc This services handles saving/ updating doctor detail
 */
export const saveClinicDoctorSchedule = (doctorId, doctorObj, clinicID) => {
  const url = doctorObj.schedule_details.scheduleId
    ? `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors/${doctorId}/schedules/${doctorObj.schedule_details.scheduleId}`
    : `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors/${doctorId}/schedules`;

  if (doctorObj.schedule_details.scheduleId) {
    return axios.put(url, doctorObj, {
      headers: getAuthHeaders()
    });
  } else {
    return axios.post(url, doctorObj, {
      headers: getAuthHeaders()
    });
  }
};

/**
 * @function deleteDoctor
 * @param doctorId
 * @desc This services handles deletion of doctor
 */
export const deleteSchedule = (doctorId, scheduleId) => {
  const clinicID = localStorage.getItem("clinic_id");
  const url = `${process.env.REACT_APP_SERVER_URL}/clinics/${clinicID}/clinic_doctors/${doctorId}/schedules/${scheduleId}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};
